import React from 'react';
import { Lock, Loader2, CheckCircle2 } from 'lucide-react';

/**
 * Big CTA button at the bottom of the vault panel. Handles all 4 visual
 * states (disabled / confirming / success / idle) so the parent component
 * only needs to pass flags.
 */
export default function VaultSubmitButton({
  mode,
  connected,
  submitting,
  justSucceeded,
  disabled,
  onClick,
}) {
  const label = (() => {
    if (submitting) {
      return (
        <>
          <Loader2 size={20} className="animate-spin" />
          Confirming in wallet…
        </>
      );
    }
    if (justSucceeded) {
      return (
        <>
          <CheckCircle2 size={20} strokeWidth={2} />
          Transaction confirmed
        </>
      );
    }
    if (!connected) return <>Connect wallet to continue</>;
    return mode === 'deposit' ? <>Stake PUSD</> : <>Burn yPUSD · Redeem</>;
  })();

  return (
    <>
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className={`mt-8 w-full inline-flex items-center justify-center gap-2 h-14 rounded-2xl font-display font-bold tracking-wide text-lg transition-all ${
          justSucceeded
            ? 'bg-emerald-400 text-palm-surface'
            : 'bg-palm-lime text-palm-surface shadow-lime hover:bg-palm-limeHover hover:-translate-y-0.5'
        } disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0`}
        data-testid={mode === 'deposit' ? 'stake-pusd-button' : 'burn-ypusd-button'}
      >
        {label}
      </button>

      <div className="mt-4 flex items-center justify-center gap-2 text-[11px] tracking-widest uppercase text-white/40">
        <Lock size={11} strokeWidth={1.7} />
        Simulated on Solana devnet · No real funds move
      </div>
    </>
  );
}
